import { render } from "./EditUserModal.vue?vue&type=template&id=824217d8"
import script from "./EditUserModal.vue?vue&type=script&lang=js"
export * from "./EditUserModal.vue?vue&type=script&lang=js"

import "./EditUserModal.vue?vue&type=style&index=0&id=824217d8&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__